import { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface HintLabelProps {
    hint?: ReactNode;
    children: ReactNode;
}

// Dotted-underline label with an info tooltip; renders plain when there's no hint.
export const HintLabel = ({ hint, children }: HintLabelProps) => {
    if (!hint) return <>{children}</>;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span className="cursor-default underline decoration-dotted underline-offset-2">{children}</span>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">{hint}</TooltipContent>
        </Tooltip>
    );
};
